import { cn } from '@/lib/utils'
import { type HTMLAttributes, forwardRef } from 'react'

interface SectionProps extends HTMLAttributes<HTMLElement> {
  variant?: 'default' | 'dark' | 'primary'
  spacing?: 'sm' | 'md' | 'lg' | 'xl'
}

export const Section = forwardRef<HTMLElement, SectionProps>(
  ({ className, variant = 'default', spacing = 'lg', ...props }, ref) => {
    return (
      <section
        ref={ref}
        className={cn(
          {
            'bg-white': variant === 'default',
            'bg-dark text-white': variant === 'dark',
            'bg-primary/10': variant === 'primary',
          },
          {
            'py-8': spacing === 'sm',
            'py-12': spacing === 'md',
            'py-16 lg:py-24': spacing === 'lg',
            'py-20 lg:py-32': spacing === 'xl',
          },
          className
        )}
        {...props}
      />
    )
  }
)

Section.displayName = 'Section'
